import React, { useState } from 'react'
import { useAsyncDebounce } from 'react-table'

export const ColumnFilter = ({ column }) => {
    const { filterValue, setFilter } = column
    const [value, setValue] = useState(filterValue || '')

    // TODO: Filter filtert alle Datensätze heraus, die den Buchstaben enthalten, nicht den ersten usw.
    // Zeitverzoegerung seit letzter Eingabe in Filterfeld, 
    // damit Tabelle nicht staendig gerendert wird (ca. 300 - 400 ms einstellen)
    const onChange = useAsyncDebounce((value) => {
        setFilter(value || undefined)
    }, 300)

    const handleChange = (e) => {
        const { value } = e.target
        setValue(value)
        onChange(value)
    }

    return (
        <span>
            {' '}
            <input value={value} onChange={handleChange} />
        </span>
    )
}

export default ColumnFilter
